module.exports = __webpack_public_path__ + "assets/2b7dd93a1f0412387b38a5b6f99358bc.mp3";